import { Component, EventEmitter, OnInit, Output, Input, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'ct-legal-modal',
  templateUrl: './legal-modal.component.html',
  styleUrls: ['./legal-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LegalModalComponent implements OnInit {

  checkboxFrom: FormGroup = this.fb.group({
    acceptTerms: [''],
  });

  @Input() show = false;
  @Input() clientId;
  @Output() acceptTerms: EventEmitter<any> = new EventEmitter();

  buttonElement: HTMLElement;

  constructor(private fb: FormBuilder, public utilsService: UtilsService) { }

  ngOnInit(): void { }

  sendAcceptTerms() {
    this.acceptTerms.emit(this.checkboxFrom);
  }

}
